export const KITCHEN_CHARGES_COPY = Object.freeze({
  title: 'Cobros de insumos',
  date: Object.freeze({
    label: (day, month, year) => `${day} ${month} ${year}`,
    shortMonths: Object.freeze(['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic']),
  }),
  table: Object.freeze({
    ticket: 'Ticket',
    date: 'Fecha',
    amount: 'Monto',
  }),
  incomplete: 'incompleto',
  lines: Object.freeze({
    item: 'Ítem',
    quantity: 'Cantidad',
    price: 'Precio',
    total: 'Total',
    subtotal: (group) => `Subtotal ${group}`,
    ticketTotal: 'Total del ticket',
    priceToConfirm: 'Precio por confirmar',
    noValue: '—',
  }),
  groups: Object.freeze({
    daily: 'Daily',
    food: 'Food',
    general: 'General',
  }),
  adjustments: Object.freeze({
    label: 'Ajuste',
    automatic: 'Automático',
    reason: 'Motivo',
    amount: 'Monto',
  }),
  states: Object.freeze({
    loading: 'Cargando tus cobros de insumos…',
    empty: 'Todavía no tienes cobros de insumos.',
    failed: 'No pudimos cargar tus cobros de insumos. Intenta de nuevo en unos minutos.',
    missingSession:
      'Tu sesión con el backoffice no está activa. Cierra sesión y vuelve a ingresar al portal para ver tus cobros de insumos.',
    notAvailable: 'Esta sección todavía no está disponible para tu país.',
    retry: 'Reintentar',
  }),
});
